import React from 'react';
import './/StyleComponents/HomeProjects.css';
import LinkButton from "./LinkButton";





const HomeProjects = () => {

    return (

        <div>
            <div className="HomeProjectsContainer">
                <h1>
                    Past Projects
                </h1>
                <p style={{paddingBottom:"10%"}}>
                    In addition to my professional work, I’ve built multiple academic and personal software projects.
                </p>
                <div className="projectLink">
                    <LinkButton link="/projects" buttonText="See projects" ></LinkButton>
                </div>
            </div>

        </div>
    )
}

export default HomeProjects;